import { pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

// react-pdf 9 bundles pdfjs-dist 4.8.69. The worker MUST match the installed
// pdfjs, and it must actually instantiate — otherwise the canvas still paints
// (main-thread fallback) but the text layer throws ("Cannot read properties of
// null (reading 'remove')") and produces zero spans, breaking text selection,
// snipping, and snippet highlighting (MDRS-134).
//
// We resolve the worker LOCALLY from the installed package via Vite's
// `new URL(..., import.meta.url)` (this is a Vite project). A cross-origin CDN
// `.mjs` module worker was the previous approach and instantiated unreliably;
// bundling the exact installed version removes the version-skew and CORS
// failure modes entirely. This module is imported app-wide via FilePreview, so
// it also corrects the older 3.11.174 CDN URL other components still set on the
// shared GlobalWorkerOptions.
export const PDF_WORKER_SRC = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

export const ZOOM_MIN = 0.5;
export const ZOOM_MAX = 3.0;
export const ZOOM_STEP = 0.1;
export const ZOOM_DEFAULT = 1.0;

pdfjs.GlobalWorkerOptions.workerSrc = PDF_WORKER_SRC;
